function Footer({ screenSize }) {
    const isAlternateLayout = screenSize === "ipad" || screenSize === "zoom";
    
    const copyrightText = "Copyright @ 2021 Moneytrain. All rights reserved.";
    
    if (isAlternateLayout) {
        return (
            <p className="text-center text-secondary mt-2 footer-text">
                {copyrightText}
            </p>
        );
    }
    
    return (
        <span className="row w-100 footer mx-0 align-content-center">
            <p className="text-center w-100 text-secondary">
                {copyrightText}
            </p>
        </span>
    );
}

export default Footer;